import LocationManagerContainer from "../../container/admin/location-manager";

const LocationManager = () => {
    return <LocationManagerContainer />;
};

export default LocationManager;